import React from "react";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { History } from "lucide-react";
import type { LifecycleRetreat } from "../../../../types/retreatLifecycle";
import { DASHBOARD_NAVY } from "./dashboardUi";
import {
  RetreatDeleteIconButton,
  RetreatEditIconButton,
  RETREAT_ACTION_ROW_SPACING,
  retreatActionButtonSx,
} from "./RetreatDashboardActionIcons";

function retreatDisplayName(row: LifecycleRetreat) {
  return row.parishName || row.title || "retreat";
}

export function RegistrationOpenRowIcons({
  row,
  frozen,
  showDelete,
  onHistory,
  onDelete,
}: {
  row: LifecycleRetreat;
  frozen: boolean;
  showDelete: boolean;
  onHistory?: (row: LifecycleRetreat) => void;
  onDelete: (row: LifecycleRetreat) => void;
}) {
  const name = retreatDisplayName(row);

  return (
    <Stack
      direction="row"
      spacing={RETREAT_ACTION_ROW_SPACING}
      alignItems="center"
      flexWrap="nowrap"
    >
      {onHistory && (
        <Tooltip title="Retreat history" placement="bottom" arrow>
          <IconButton
            size="small"
            aria-label={`Retreat history for ${name}`}
            onClick={() => onHistory(row)}
            sx={{ ...retreatActionButtonSx, color: DASHBOARD_NAVY }}
          >
            <History size={17} />
          </IconButton>
        </Tooltip>
      )}
      {frozen ? (
        <RetreatEditIconButton
          title="Edit (Disabled)"
          ariaLabel={`View or edit registration for ${name}`}
          disabled
        />
      ) : (
        <RetreatEditIconButton
          title="View or edit registration"
          ariaLabel={`View or edit registration for ${name}`}
          to={`/retreat-setup/${row.id}`}
        />
      )}
      {showDelete && (
        <RetreatDeleteIconButton
          title={frozen ? "Deletion disabled (Frozen)" : "Delete retreat record"}
          ariaLabel={`Delete retreat record for ${name}`}
          disabled={frozen}
          onClick={() => !frozen && onDelete(row)}
        />
      )}
    </Stack>
  );
}
